module.exports = {
  "id": "droplet",
  "title": "droplet",
  "image": "provision/parts/droplet/droplet.png",
  "info": [
    {
      "text": "Add a drop of water to your project",
      "image": "provision/parts/droplet/droplet.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/droplet/droplet.png"
} ;